import { render, staticRenderFns } from "./customer-details.component.vue?vue&type=template&id=dc1795dc&scoped=true&"
import script from "./customer-details.component.ts?vue&type=script&lang=ts&"
export * from "./customer-details.component.ts?vue&type=script&lang=ts&"
import style0 from "./customer-details.component.scss?vue&type=style&index=0&id=dc1795dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1795dc",
  null
  
)

export default component.exports